import { useConnectorsMap } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorsMap.js';
import { useUserSettingsQuery } from '#pplx/frontend/apps/ask/user-settings/hooks/useUserSettingsQuery.js';
import { FILE_BASED_CONNECTORS } from '#pplx/frontend/components/utils/consts.js';
import { useMemo } from 'react';
/**
 * Returns enabled connectors (connectors that are connected)
 */
export const useEnabledConnectors = ({ reason, enabled = true, }) => {
    const { connectors: connectorsFromSettings, isLoading: isConnectorsLoading, isStale: isConnectorsStale, refetch: refetchConnectors, } = useUserSettingsQuery({
        reason,
        enabled,
    });
    const { connectorsMap } = useConnectorsMap({ reason, enabled });
    // TODO: Separate File Connectors type from other connectors bc currently they are all in the same type
    const enabledFileConnectors = useMemo(() => {
        return (connectorsFromSettings?.connectors ?? []).filter((connector) => FILE_BASED_CONNECTORS.includes(connector.name) &&
            connectorsMap[connector.name] &&
            connectorsMap[connector.name].connected);
    }, [connectorsMap, connectorsFromSettings]);
    const enabledNonFileConnectors = useMemo(() => {
        return (connectorsFromSettings?.connectors ?? []).filter((connector) => !FILE_BASED_CONNECTORS.includes(connector.name) &&
            connectorsMap[connector.name] &&
            connectorsMap[connector.name].connected);
    }, [connectorsMap, connectorsFromSettings]);
    const enabledConnectors = useMemo(() => {
        return (connectorsFromSettings?.connectors ?? []).filter((connector) => connectorsMap[connector.name] && connectorsMap[connector.name].connected);
    }, [connectorsMap, connectorsFromSettings]);
    return useMemo(() => ({
        enabledFileConnectors,
        enabledNonFileConnectors,
        enabledConnectors,
        isConnectorsLoading,
        isConnectorsStale,
        refetchConnectors,
    }), [
        enabledConnectors,
        enabledFileConnectors,
        enabledNonFileConnectors,
        isConnectorsLoading,
        isConnectorsStale,
        refetchConnectors,
    ]);
};
//# sourceMappingURL=useEnabledConnectors.js.map